"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isBetween = void 0;

/**
 * Check if value is inside open or closed interval
 *
 * @param  {number}   left         Left limit
 * @param  {number}   right        Right limit
 * @param  {Object}   arg3         Props
 * @param  {boolean}  arg3.closed  If intervals is closed or not
 *
 * @return {boolean}
 *
 * @tag Number
 * @signature (left: number, right: number, props: Object)
 *  => (source: number): boolean
 *
 * @example
 * between(2, 5)(5)
 * // => false
 *
 * between(2, 5, {closed: true})(5)
 * // => true
 */
var isBetween = function isBetween(left, right) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$closed = _ref.closed,
      closed = _ref$closed === void 0 ? false : _ref$closed;

  return function (source) {
    if (left > right) {
      throw new Error("Left interval limit must be less than right limit");
    }

    return closed === false ? source > left && source < right : source >= left && source <= right;
  };
};

exports.isBetween = isBetween;